var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signup-sections"},[_c('signup-section-basic'),_vm._v(" "),_c('signup-section-company'),_vm._v(" "),_c('signup-section-users'),_vm._v(" "),_c('signup-section-packages'),_vm._v(" "),_c('signup-section-agreement')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }